import React, {useEffect, useState} from 'react';
import {Icon} from '@blueprintjs/core';
import {Cell, Column, ColumnHeaderCell, Table2} from '@blueprintjs/table';

import {columnIcon} from '../../../utils/data';

interface ResultSuccessProps {
  result: any;
}

const columnHeaderCellRenderer = (columnsMap: any) => (columnIndex: number) => {
  const column = columnsMap[columnIndex];
  const icon = columnIcon({column: column, size: 18, color: '#bbb'});

  return (
    <ColumnHeaderCell className="query-result__success__table__header">
      <div className="bp4-table-truncated-text">{column.name}</div>
      {icon && <Icon icon={icon} iconSize={12}/>}
    </ColumnHeaderCell>
  );
};

const ResultSuccess = ({
  result,
}: ResultSuccessProps) => {
  const key = (result.key + '_' + result.status);

  const [columns, setColumns] = useState<any>({});
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    if (!result.value || !result.value?.selected_columns) {
      return;
    }
    const {selected_columns, data} = result.value;

    const selectedColumns = selected_columns
      .map((column: any) => ({
        name: column.name,
        type: column.type
      }))
      .reduce((acc: any, val: string, index: number) => {
        acc[index] = val;
        return acc;
      }, {});

    setColumns(selectedColumns);
    setData(data);
  }, [key]);

  const getCellData = (rowIndex: number, columnIndex: number) => {
    const column = columns[columnIndex];
    const row = data[rowIndex];
    return row[column.name];
  };

  const cellRenderer = (rowIndex: number, columnIndex: number) => {
    const cellData = getCellData(rowIndex, columnIndex);

    let data = cellData === null ? 'null' : cellData;
    data = data === true ? 'true' : data;
    data = data === false ? 'false' : data;

    return <Cell>{data}</Cell>;
  };

  return (
    <div className="query-result__success">
      <Table2
        numRows={data.length}
        className="query-result__success__table"
        enableFocusedCell={true}
        key={key}
      >
        {
          Object.keys(columns).map((column: any, index: number) => (
            <Column
              key={index}
              name={column.name}
              cellRenderer={cellRenderer}
              columnHeaderCellRenderer={columnHeaderCellRenderer(columns)}
            />
          ))
        }
      </Table2>
    </div>
  );
};

export default ResultSuccess;
